import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="pt-12 pb-4 px-4 bg-white text-center" data-id="element-56" data-mp="2hukss24eivsx">
      <div className="max-w-4xl mx-auto" data-id="element-57" data-mp="2hw45jiqumopy">
        <p className="md:text-xs text-gray-400 tracking-wider mb-4 text-[12px] font-[600] font-[Figtree,_sans-serif]" data-id="element-58" data-mp="23vl26oxbw6u4">
          "Recursos visuales y prácticos para trabajar emociones, convivencia,
          diversidad, autocuidado y ciudadanía digital durante todo el año"
        </p>

        <h1 className="text-3xl md:text-5xl font-black mb-1 leading-tight tracking-tight" data-id="element-59" data-mp="30l2hlvm45790">
          <span className="px-2 text-[#EF5B4C] bg-[#FFFFFF] text-[24px]" data-id="element-60" data-mp="2mtxegjjjdwtx">
            MEGAPACK ESI PRIMARIA
          </span>
        </h1>

        <h2 className="md:text-2xl font-extrabold mb-3 text-gray-800 text-[16px]" data-id="element-61" data-mp="2rrywd1587q3t">
          Material diseñado especialmente para docentes que necesitan trabajar
          Educación Sexual Integral de forma simple, organizada y con
          actividades listas para usar.
        </h2>

        <div className="block max-w-[600px] mx-auto mb-3" data-id="element-62" data-mp="2ff0ewur5wph2">
          <img src="https://cdn.magicpatterns.com/uploads/qw9XxQHCdALsJhS46viPhX/mockup_principal.png" alt="Megapack ESI Primaria" className="w-full h-auto object-contain drop-shadow-2xl rounded-xl" data-id="element-63" data-mp="2fd5vxlzgb7fm" />
        </div>

        <div className="text-lg md:text-xl mb-4 text-gray-700 space-y-2 max-w-3xl mx-auto font-medium" data-id="element-64" data-mp="2kdtls4by1i89">
          <p className="text-[14px]" data-id="element-65" data-mp="2z26mtfpw1r9m">
            Actividades listas para imprimir y entrar al aula.
          </p>
        </div>

        <div className="flex flex-nowrap items-center justify-center gap-2 md:gap-3 mb-5 whitespace-nowrap" data-id="element-66" data-mp="2u6ixn0beoy44">
          <span className="text-base md:text-xl font-bold text-gray-400 line-through" data-id="element-67" data-mp="381tjxpbl4awv">
            ARS $39.990
          </span>
          <span className="inline-flex flex-shrink-0 items-center rounded-full bg-red-600 px-2.5 py-1 text-[11px] md:text-sm font-black uppercase leading-none text-white shadow-md" data-id="element-68" data-mp="1dpn247o6qvvl">
            50% OFF
          </span>
          <span className="text-2xl md:text-4xl font-black" style={{
          color: '#EF5C4C'
        }} data-id="element-69" data-mp="38uctkj7e3zgs">
            $19.990
          </span>
        </div>

        <div className="bg-[#EAF8F6] rounded-2xl p-5 max-w-md mx-auto border border-[#C9EDE8]" data-id="element-70" data-mp="3iqzf7a7jiujv">
          <p className="text-lg font-black text-gray-900 mb-3" data-id="element-71" data-mp="3mtm0stdmbj8m">
            👉 Beneficios del material
          </p>
          <div className="space-y-2 text-left" data-id="element-72" data-mp="3rr5qcpfrnifv">
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-73" data-mp="3rqcrean1tx8a">
              <span className="text-green-600 mr-2 text-lg" data-id="element-74" data-mp="k1nm6qnmid9">✔️</span>{' '}
              Actividades listas para usar
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-75" data-mp="abfr0plq82bo">
              <span className="text-green-600 mr-2 text-lg" data-id="element-76" data-mp="adidx0rl1fc6">✔️</span> Menos
              tiempo de planificación
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-77" data-mp="jbuffxtzlxje">
              <span className="text-green-600 mr-2 text-lg" data-id="element-78" data-mp="23u6axjwkylej">✔️</span> Recursos
              visuales y claros
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-79" data-mp="1yv1zsnq3idlk">
              <span className="text-green-600 mr-2 text-lg" data-id="element-80" data-mp="1ut830qj0ttqo">✔️</span> Mayor
              participación de los estudiantes
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-81" data-mp="1pw7y4ixwqx15">
              <span className="text-green-600 mr-2 text-lg" data-id="element-82" data-mp="2mjuqa4ny7t8s">✔️</span> Primer
              Ciclo y Segundo Ciclo completos
            </p>
            <p className="text-base font-semibold text-gray-800 flex items-center" data-id="element-83" data-mp="2ilf6e9n5z0zl">
              <span className="text-green-600 mr-2 text-lg" data-id="element-84" data-mp="2dqrgq7gfc0jf">✔️</span> Material
              para todo el año escolar
            </p>
          </div>
        </div>
      </div>
    </section>;
}